class FadeSlider extends HTMLElement {
  constructor() {
    super();
    // Seleccionamos los elementos clave
    this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
    this.nextButton = this.querySelector('.slider-button--next');
    this.prevButton = this.querySelector('.slider-button--prev');
    
    this.currentIndex = 0;
    
    const sliderWrapper = this.querySelector('.slideshow');
    this.autoplay = sliderWrapper?.dataset.autoplay === 'true';
    this.speed = parseInt(sliderWrapper?.dataset.speed) * 1000 || 5000;
    this.timer = null;

    if (this.slides.length > 1) {
      this.init();
    } else if (this.slides[0]) {
      // Si solo hay una imagen, nos aseguramos de que sea visible
      this.slides[0].style.opacity = '1';
      this.slides[0].style.visibility = 'visible';
    }
  }

  init() {
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
    }
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
      });
    }

    this.updateSlides();
    if (this.autoplay) this.play();

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => { if(this.autoplay) this.play() });
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.updateSlides();
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.updateSlides();
  }

  updateSlides() {
    this.slides.forEach((slide, index) => {
      if (index === this.currentIndex) {
        slide.setAttribute('aria-hidden', 'false');
        slide.classList.add('is-active');
        // Forzamos el CSS vital desde JS
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
        slide.style.zIndex = '2';
      } else {
        slide.setAttribute('aria-hidden', 'true');
        slide.classList.remove('is-active');
        // Ocultamos
        slide.style.opacity = '0';
        slide.style.visibility = 'hidden';
        slide.style.zIndex = '1';
      }
    });
  }

  play() {
    this.pause();
    this.timer = setInterval(() => this.nextSlide(), this.speed);
  }

  pause() {
    if (this.timer) clearInterval(this.timer);
  }
}

// Registramos el nuevo componente independiente
if (!customElements.get('fade-slider')) {
  customElements.define('fade-slider', FadeSlider);
}